import { useWindowDimensions } from '../../shared/hooks/useWindowDimensions';
import { RoutineFold } from './routineFold';

export const Routines = () => {
  const windowDimensions = useWindowDimensions();
  const maxHeight = (windowDimensions?.height ?? 0) - 185; // substract banner + padding height

  return <RoutineFold maxHeight={maxHeight} />;
};
